import React, { useState } from "react";
import App from "./App";
import Dashboard from "./Dashboard";
import Team from "./Team";

// Switches views in the browser. Every request to the server must carry a fresh Shopify signature, so in-app links can't reload the page
export default function Bridge(props) {
  const [view, setView] = useState(props.view || "app");

  if (view == "dashboard") {
    return <Dashboard {...props} onNavigate={setView} />;
  } else if (view == "team") {
    return <Team {...props} onNavigate={setView} />;
  }
  return <App {...props} onNavigate={setView} />;
}
